import { render, staticRenderFns } from "./addIndBeneficiary.vue?vue&type=template&id=40b94ff4"
import script from "./addIndBeneficiary.vue?vue&type=script&lang=js"
export * from "./addIndBeneficiary.vue?vue&type=script&lang=js"
import style0 from "./addIndBeneficiary.vue?vue&type=style&index=0&id=40b94ff4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports